import React, { useState } from "react";
import AvatarName from "../UniversalComponents/AvatarName";
import CustomDropdown from "../UniversalComponents/CustomDropdown";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/DeleteAction.svg";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { mySpaceTableRemoveUserAccess, mySpaceTableUpdateUserAccess } from "../../utils/api/mySpaceApi";

const ProfileCardSharedPerson = ({ key, person, containerId = null, reRenderParent }) => {
  const dispatch = useDispatch();

  const DROPDOWN_OPTIONS = {
    isSharedPerson: true,

    selectedOptionBgColor: "#F3F5F7",
    options: [
      {
        text: "Only Edit",
        id: 2,
        data: {
          id: 2,
          label: "Only Edit",
          value: "write",
        },
        icon: <EditIcon className="mr-3 text-[#969BA9] group-hover:text-[#1D4469]" />,
        onClick: (option) => handleStatusUpdate(option),
        afterDivider: false,
      },
      {
        text: "Add, Edit and Delete",
        id: 2,
        data: {
          id: 2,
          label: "Can Edit,Delete",
          value: "delete",
        },
        icon: <EditIcon className="mr-3 text-[#969BA9] group-hover:text-[#1D4469]" />,
        onClick: (option) => handleStatusUpdate(option),
        afterDivider: false,
      },
      {
        text: <span className="text-F84545">Remove</span>,
        id: 3,
        data: {
          id: 3,
          label: "Add, Edit, Delete",
          value: "delete",
        },
        icon: <DeleteIcon className="mr-3 text-F84545 group-hover:text-[#1D4469]" />,
        onClick: (option) => handleRemoveAccess(option),
        afterDivider: true,
      },
    ],
  };

  const [selectedAccessType, setSelectedAccessType] = useState(
    DROPDOWN_OPTIONS?.options?.find((option) => option?.data?.value === person?.access)?.text
  );

  const handleStatusUpdate = async (selectedDropdownOption) => {
    try {
      const response = await mySpaceTableUpdateUserAccess({
        params: { containerId: containerId },
        body: { access: selectedDropdownOption?.value, userId: person?.user_id },
      });
      if (response?.success) {
        setSelectedAccessType(selectedDropdownOption?.text);
        reRenderParent((prev) => !prev); // Trigger re-render in parent component
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
      } else {
        // Handle error case
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
    }
  };

  const handleRemoveAccess = async () => {
    try {
      const response = await mySpaceTableRemoveUserAccess({
        params: { containerId: containerId },
        body: { userId: person?.user_id },
      });
      if (response?.success) {
        setSelectedAccessType(null);
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
        reRenderParent((prev) => !prev); // Trigger re-render in parent component
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
    }
  };

  return (
    <div key={key} className="flex items-center justify-between border-b py-2 border-BECBD3">
      <div className=" flex gap-x-4 items-center">
        <span>
          <AvatarName
            name={getInitials(person?.user_name)}
            size="medium"
            bgColor={"#e8ecf299"}
            textColor={"#7C7C83"}
            borderColor={"#ABABAC"}
          />
        </span>
        <span className="text-12 font-500 text-1D4469">{person?.user_name}</span>
      </div>
      <div className="relative">
        <CustomDropdown options={DROPDOWN_OPTIONS} existingOption={selectedAccessType} />
      </div>
    </div>
  );
};

export default ProfileCardSharedPerson;
